import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color", "strokeWidth"];
var __jsx = React.createElement;
import React from "react";
const ChevronDownIcon = _ref => {
  let {
      size = "16",
      color = "currentColor",
      strokeWidth
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54354 4.60604C1.7266 4.42299 2.0234 4.42299 2.20646 4.60604L7.5 9.89959L12.7935 4.60604C12.9766 4.42299 13.2734 4.42299 13.4565 4.60604C13.6395 4.7891 13.6395 5.0859 13.4565 5.26896L7.83146 10.894C7.6484 11.077 7.3516 11.077 7.16854 10.894L1.54354 5.26896C1.36049 5.0859 1.36049 4.7891 1.54354 4.60604Z",
    fill: color,
    strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 0
  }));
};
export default ChevronDownIcon;